export const COLUMNS = [
  { sortKey: 'name', name: 'Name' },
  { sortKey: 'description', name: 'Description' },
  { name: 'Edit', width: '8%' },
  { name: 'Delete', width: '8%' },
];

export const MAX_NAME_CHAR_LENGTH = 255;
export const MAX_DESCRIPTION_CHAR_LENGTH = 200;
export const MAX_NAME_ERR_MSG = `Name must be less than or equal to ${MAX_NAME_CHAR_LENGTH} characters.`;
export const MAX_DESCRIPTION_ERR_MSG = `Description must be less than or equal to ${MAX_DESCRIPTION_CHAR_LENGTH} characters.`;
